import { useChainedTimeout as e } from "../../hooks/useTimeout.js";
import { useClickOutsideWithRef as t } from "../../hooks/useClickOutside.js";
import n from "../../hooks/useMergeRefs.js";
import { useAnchorName as r, usePopover as i } from "../../hooks/useAnchoredPopover.js";
import { PLACEMENT as a } from "../../values/Placement.js";
import { TRIGGER as o } from "../../values/Trigger.js";
import s from "../../utils/getReactElementRef.js";
import { useUncontrolledProp as c } from "../../hooks/useUncontrollable.js";
import { useOverlayArrowPlacement as l } from "./useOverlayArrowPlacement.js";
import u, { useCallback as d, useLayoutEffect as f, useRef as ee, useState as p } from "react";
import { Fragment as m, jsxs as te } from "react/jsx-runtime";
//#region src/components/overlay/OverlayTrigger.tsx
var h = (a) => {
	let { show: h, defaultShow: g = !1, trigger: _ = o.HOVER, delay: v, overlay: y, placement: b = "top", positionTarget: x, onToggle: S = () => {}, rootClose: C = !0, children: w } = a, [T, E] = c(h, g, S), D = ee(""), O = e(), k = u.Children.only(w), A = y, { onFocus: j, onBlur: M, onClick: N } = k.props, P = (e, t, n) => {
		let [r] = t, i = r.currentTarget, a = r.relatedTarget;
		(!a || a !== i) && !i.contains(a) && e(...t);
	}, F = () => {
		if (O.clear(), D.current = "show", v === 0 || typeof v != "number" && !v?.show) {
			E(!0);
			return;
		}
		O.set(() => {
			D.current === "show" && E(!0);
		}, typeof v == "number" ? v : v?.show);
	}, I = () => {
		if (O.clear(), D.current = "hide", typeof v == "number" || !v?.hide) {
			E(!1);
			return;
		}
		O.set(() => {
			D.current === "hide" && E(!1);
		}, v?.hide);
	}, L = d((e) => {
		F(), j?.(e);
	}, [F, j]), R = d((e) => {
		I(), M?.(e);
	}, [I, M]), z = d((e) => {
		E(!T), N?.(e);
	}, [
		N,
		E,
		T
	]), B = d((...e) => {
		P(F, e, "fromElement");
	}, [F]), V = d((...e) => {
		P(I, e, "toElement");
	}, [I]), [H, U] = p(null), [W, G] = p(null), K = n(s(k), U), q = n(s(A), G), J = r("overlay-trigger"), Y = x ?? H;
	f(() => {
		if (!x) return;
		let e = x.style.getPropertyValue("anchor-name");
		return x.style.setProperty("anchor-name", J), () => {
			if (e) {
				x.style.setProperty("anchor-name", e);
				return;
			}
			x.style.removeProperty("anchor-name");
		};
	}, [J, x]), i(W, T);
	let { arrowPlacement: X, arrowOffsetInline: Z, arrowOffsetBlock: ne } = l({
		placement: b,
		show: T,
		triggerElement: Y,
		overlayElement: W
	}), re = d((e) => {
		let t = H?.contains(e.target), n = W?.contains(e.target);
		T && C && !t && !n && I();
	}, [
		H,
		W,
		C,
		I
	]);
	t(H, re, void 0, T && C);
	let Q = {
		ref: K,
		style: {
			...k.props.style || {},
			anchorName: x ? void 0 : J
		}
	};
	_ === "click" ? Q.onClick = z : _ === "focus" ? (Q.onFocus = L, Q.onBlur = R) : _ === "hover" && (Q.onMouseOver = B, Q.onMouseOut = V);
	let $ = W?.classList.contains("tooltip"), ie = u.cloneElement(A, {
		ref: q,
		placement: b,
		"data-overlay-trigger": "",
		"data-overlay-placement": b,
		"data-overlay-arrow-placement": X,
		style: {
			...A.props.style || {},
			positionAnchor: J,
			"--overlay-arrow-auto-offset-inline": `${Z}px`,
			"--overlay-arrow-auto-offset-block": `${ne}px`,
			"--overlay-anchor-width": $ && Y ? `${Y.offsetWidth}px` : void 0,
			"--overlay-anchor-height": $ && Y ? `${Y.offsetHeight}px` : void 0
		}
	});
	return /* @__PURE__ */ te(m, { children: [u.cloneElement(k, Q), T && ie] });
};
h.TRIGGER_CLICK = o.CLICK, h.TRIGGER_HOVER = o.HOVER, h.TRIGGER_FOCUS = o.FOCUS, h.TOP_START = a.TOP_START, h.TOP = a.TOP, h.TOP_END = a.TOP_END, h.RIGHT_START = a.RIGHT_START, h.RIGHT = a.RIGHT, h.RIGHT_END = a.RIGHT_END, h.BOTTOM_START = a.BOTTOM_START, h.BOTTOM = a.BOTTOM, h.BOTTOM_END = a.BOTTOM_END, h.LEFT_START = a.LEFT_START, h.LEFT = a.LEFT, h.LEFT_END = a.LEFT_END;
//#endregion
export { h as default };

//# sourceMappingURL=OverlayTrigger.js.map